import { render, staticRenderFns } from "./CurationFilterReceiveLayout.vue?vue&type=template&id=2d18e676&scoped=true"
import script from "./CurationFilterReceiveLayout.vue?vue&type=script&lang=js"
export * from "./CurationFilterReceiveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18e676",
  null
  
)

export default component.exports